import { insertAfter } from 'App/babel/store/helpers/array';
import { generateUserFilter } from 'App/upsales/common/attributes/filter/userFilter';
import getAppSyncStatusFilter from 'App/babel/filters/AppSyncStatus';
import FieldTranslations from 'Resources/FieldTranslations';
import Competitor from 'Resources/Competitor';
import RequestBuilder, { comparisonTypes } from 'Resources/RequestBuilder';
import logError from 'App/babel/helpers/logError';

angular.module('upAttributes').service('OrderAttributes', [
	'FilterType',
	'DisplayType',
	'OrderRowAttributes',
	'AppService',
	'FeatureHelper',
	'$translate',
	function (FilterType, DisplayType, OrderRowAttributes, AppService, FeatureHelper, $translate) {
		return function () {
			var attributes = {
				id: {
					title: 'order.id',
					field: 'id',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					selectableColumn: true,
					sortable: 'id'
				},
				description: {
					title: 'default.description',
					field: 'description',
					type: FilterType.String,
					displayType: DisplayType.String,
					inputType: 'text',
					groupable: false,
					sortable: 'description',
					selectableColumn: true
				},
				date: {
					title: 'order.date',
					field: 'date',
					type: FilterType.Date,
					displayType: DisplayType.Date,
					// inputType: 'date',
					sortable: 'date',
					selectableColumn: true,
					elevioId: 276
				},
				closeDate: {
					title: 'default.closeDate',
					field: 'closeDate',
					type: FilterType.Date,
					displayType: DisplayType.Date,
					// inputType: 'date',
					sortable: 'closeDate',
					selectableColumn: true,
					elevioId: 277
				},
				value: {
					title: 'default.value',
					field: 'value',
					type: FilterType.String,
					displayType: DisplayType.Number,
					selectableColumn: true,
					sortable: 'valueInMasterCurrency',
					elevioId: 965
				},
				contributionMargin: {
					title: 'default.contributionMargin',
					field: 'contributionMargin',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					selectableColumn: false,
					sortable: 'contributionMargin'
				},
				contributionMarginLocalCurrency: {
					title: 'default.contributionMargin',
					field: 'contributionMarginLocalCurrency',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					sortable: 'contributionMarginLocalCurrency'
				},
				contributionMarginInRoleCurrency: {
					title: 'default.contributionMargin',
					field: 'contributionMarginInRoleCurrency',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					sortable: 'contributionMarginInRoleCurrency'
				},
				weightedContributionMargin: {
					title: 'default.weightedContributionMargin',
					field: 'weightedContributionMargin',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedContributionMargin'
				},
				weightedContributionMarginInRoleCurrency: {
					title: 'default.weightedContributionMarginInRoleCurrency',
					field: 'weightedContributionMarginInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedContributionMarginInRoleCurrency'
				},
				weightedContributionMarginLocalCurrency: {
					title: 'default.contributionMargin',
					field: 'weightedContributionMarginLocalCurrency',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					sortable: 'weightedContributionMarginLocalCurrency'
				},
				valueInMasterCurrency: {
					title: 'default.valueInMasterCurrency',
					field: 'valueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'valueInMasterCurrency'
				},
				valueIncontributionMargin: {
					title: 'default.contributionMargin',
					field: 'contributionMargin',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'valueIncontributionMargin'
				},
				weightedValue: {
					title: 'default.weightedValue',
					field: 'weightedValue',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedValue'
				},
				weightedValueInMasterCurrency: {
					title: 'default.weightedValueInMasterCurrency',
					field: 'weightedValueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedValueInMasterCurrency'
				},
				agreement: {
					title: 'default.agreement',
					field: 'agreement.id',
					displayAttr: 'description',
					displayType: DisplayType.String,
					link: 'agreement',
					groupable: false,
					sortable: 'agreement.description',
					selectableColumn: false,
					parent: 'agreement',
					attr: {
						id: {
							field: 'agreement.id',
							type: FilterType.Number
						},
						description: {
							field: 'agreement.description',
							type: FilterType.String
						}
					}
				},
				user: {
					title: 'default.user',
					field: 'user.id',
					type: FilterType.Number,
					displayType: DisplayType.String,
					// inputType: 'select',
					displayAttr: 'name',
					parent: 'user',
					sortable: 'user.name',
					attr: {
						id: {
							field: 'user.id',
							type: FilterType.Number
						},
						name: {
							field: 'user.name',
							type: FilterType.String
						},
						role: {
							field: 'user.role',
							type: FilterType.Object,
							attr: {
								id: {
									field: 'user.role.id',
									type: FilterType.Number
								}
							}
						}
					},
					selectableColumn: true
				},
				users: {
					title: 'default.accountManager',
					field: 'client.user.id',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					filterName: 'userId',
					// inputType: 'select',
					displayAttr: 'name',
					parent: 'users',
					attr: {
						id: {
							field: 'client.user.id',
							type: FilterType.Number
						},
						name: {
							field: 'client.user.name',
							type: FilterType.String
						}
					},
					groupable: false,
					selectableColumn: true
				},
				contact: {
					title: 'default.contact',
					field: 'contact.id',
					// inputType: 'select',
					displayAttr: 'name',
					displayType: DisplayType.String,
					link: 'contacts',
					groupable: false,
					sortable: 'contact.name',
					selectableColumn: true,
					parent: 'contact',
					attr: {
						id: {
							field: 'contact.id',
							type: FilterType.Number
						},
						name: {
							field: 'contact.name',
							type: FilterType.String
						}
					}
				},
				account: {
					title: 'default.account',
					field: 'client.id',
					// inputType: 'select',
					displayAttr: 'name',
					displayType: DisplayType.String,
					link: 'accounts',
					groupable: false,
					sortable: 'client.name',
					selectableColumn: false,
					parent: 'client',
					attr: {
						id: {
							field: 'client.id',
							type: FilterType.Number
						},
						name: {
							field: 'client.name',
							type: FilterType.String
						},
						user: {
							field: 'client.user',
							type: FilterType.Object,
							attr: {
								id: {
									field: 'client.user.id',
									type: FilterType.Number
								}
							}
						}
					}
				},
				probability: {
					title: 'default.probability',
					field: 'probability',
					inputType: 'text',
					type: FilterType.Number,
					displayType: DisplayType.String,
					filterName: 'probability',
					comparisonTypes: ['Equals', 'NotEquals'],
					groupable: false,
					sortable: 'probability',
					selectableColumn: true
				},
				notes: {
					field: 'notes',
					type: FilterType.String
				},
				project: {
					title: 'default.campaigns',
					field: 'project.id',
					inputType: 'select',
					displayAttr: 'name',
					displayType: DisplayType.String,
					groupable: false,
					selectableColumn: true,
					parent: 'project',
					attr: {
						id: {
							field: 'project.id',
							type: FilterType.Number
						},
						name: {
							field: 'project.name',
							type: FilterType.String
						}
					}
				},
				product: {
					title: 'default.product',
					field: 'orderRow.product.id',
					inputType: 'select',
					type: FilterType.String,
					displayType: DisplayType.String,
					comparisonTypes: ['Equals', 'NotEquals'],
					groupable: false,
					filter: {
						multiple: true,
						resource: 'Product',
						type: 'list',
						searchField: 'name',
						displayText: _.property('name'),
						title: 'default.account'
					},
					selectableColumn: true
				},
				orderRow: {
					parent: 'orderRow',
					attr: OrderRowAttributes.attr
				},
				stage: {
					title: 'default.stage',
					field: 'stage.id',
					inputType: 'select',
					displayAttr: 'name',
					displayType: DisplayType.String,
					filterName: 'orderStage',
					comparisonTypes: ['Equals', 'NotEquals'],
					groupable: true,
					sortable: 'stage.name',
					selectableColumn: true,
					parent: 'stage',
					attr: {
						id: {
							field: 'stage.id',
							type: FilterType.Number
						},
						name: {
							field: 'stage.name',
							type: FilterType.String
						}
					}
				},
				currency: {
					title: 'default.currency',
					field: 'currency',
					type: FilterType.String,
					displayType: DisplayType.String
				},
				currencyRate: {
					title: 'default.currencyRate',
					field: 'currencyRate',
					type: FilterType.Float,
					displayType: DisplayType.Number
				},
				clientConnection: {
					title: 'default.clientConnection',
					field: 'clientConnection.id',
					displayType: DisplayType.String,
					parent: 'clientConnection',
					attr: {
						id: {
							field: 'clientConnection.id',
							type: FilterType.Number
						},
						name: {
							field: 'clientConnection.name',
							type: FilterType.String
						}
					}
				},
				closedCol: {
					title: 'order.closed',
					field: 'closedCol',
					displayType: DisplayType.String,
					sortable: 'date',
					groupable: false,
					selectableColumn: true
				},
				descStageCol: {
					title: 'order.descriptionAndStage',
					field: 'descStageCol',
					displayType: DisplayType.String,
					sortable: 'description',
					groupable: false,
					selectableColumn: true
				},
				custom: {},
				journeyStep: {
					title: 'default.journeyStep',
					field: 'client.journeyStep',
					displayType: DisplayType.String,
					groupable: false,
					selectableColumn: true
				},
				clientJourneyStep: {
					title: 'default.journeyStepClient',
					field: 'client.journeyStep',
					displayType: DisplayType.String,
					groupable: false,
					selectableColumn: false
				},
				contactJourneyStep: {
					title: 'default.journeyStepContact',
					field: 'contact.journeyStep',
					displayType: DisplayType.String,
					groupable: false,
					selectableColumn: false
				},
				oneOffValue: {
					title: 'default.oneOffValue',
					field: 'oneOffValue',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'oneOffValue'
				},
				oneOffValueInMasterCurrency: {
					title: 'default.oneOffValueInMasterCurrency',
					field: 'oneOffValueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'oneOffValueInMasterCurrency'
				},
				weightedOneOffValue: {
					title: 'default.weightedOneOffValue',
					field: 'weightedOneOffValue',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedOneOffValue'
				},
				weightedOneOffValueInMasterCurrency: {
					title: 'default.weightedOneOffValueInMasterCurrency',
					field: 'weightedOneOffValueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedOneOffValueInMasterCurrency'
				},
				oneOffValueInRoleCurrency: {
					title: 'default.oneOffValueInRoleCurrency',
					field: 'oneOffValueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'oneOffValueInRoleCurrency'
				},
				weightedOneOffValueInRoleCurrency: {
					title: 'default.weightedOneOffValueInRoleCurrency',
					field: 'weightedOneOffValueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedOneOffValueInRoleCurrency'
				},
				valueInRoleCurrency: {
					title: 'default.valueInRoleCurrency',
					field: 'valueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'valueInRoleCurrency'
				},
				weightedValueInRoleCurrency: {
					title: 'default.weightedValueInRoleCurrency',
					field: 'weightedValueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedValueInRoleCurrency'
				},
				annualValue: {
					title: 'default.annualValue',
					field: 'annualValue',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'annualValue'
				},
				annualValueInMasterCurrency: {
					title: 'default.annualValueInMasterCurrency',
					field: 'annualValueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'annualValueInMasterCurrency'
				},
				weightedAnnualValue: {
					title: 'default.weightedAnnualValue',
					field: 'weightedAnnualValue',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedAnnualValue'
				},
				weightedAnnualValueInMasterCurrency: {
					title: 'default.weightedAnnualValueInMasterCurrency',
					field: 'weightedAnnualValueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedAnnualValueInMasterCurrency'
				},
				annualValueInRoleCurrency: {
					title: 'default.annualValueInRoleCurrency',
					field: 'annualValueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'annualValueInRoleCurrency'
				},
				weightedAnnualValueInRoleCurrency: {
					title: 'default.weightedAnnualValueInRoleCurrency',
					field: 'weightedAnnualValueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedAnnualValueInRoleCurrency'
				},
				monthlyValue: {
					title: 'default.monthlyValue',
					field: 'monthlyValue',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'monthlyValue'
				},
				monthlyValueInMasterCurrency: {
					title: 'default.monthlyValueInMasterCurrency',
					field: 'monthlyValueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'monthlyValueInMasterCurrency'
				},
				weightedMonthlyValue: {
					title: 'default.weightedMonthlyValue',
					field: 'weightedMonthlyValue',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedMonthlyValue'
				},
				weightedMonthlyValueInMasterCurrency: {
					title: 'default.weightedMonthlyValueInMasterCurrency',
					field: 'weightedMonthlyValueInMasterCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedMonthlyValueInMasterCurrency'
				},
				monthlyValueInRoleCurrency: {
					title: 'default.monthlyValueInRoleCurrency',
					field: 'monthlyValueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'monthlyValueInRoleCurrency'
				},
				weightedMonthlyValueInRoleCurrency: {
					title: 'default.weightedMonthlyValueInRoleCurrency',
					field: 'weightedMonthlyValueInRoleCurrency',
					type: FilterType.String,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'weightedMonthlyValueInRoleCurrency'
				},
				confirmedBudget: {
					title: 'order.confirmedBudget',
					field: 'confirmedBudget',
					type: FilterType.Number,
					displayType: DisplayType.String,
					selectableColumn: false,
					sortable: 'confirmedBudget'
				},
				confirmedDate: {
					title: 'order.confirmedDate',
					field: 'confirmedDate',
					type: FilterType.Date,
					displayType: DisplayType.Date,
					selectableColumn: false,
					sortable: 'confirmedDate'
				},
				confirmedSolution: {
					title: 'order.confirmedSolution',
					field: 'confirmedSolution',
					type: FilterType.Boolean,
					selectableColumn: false,
					sortable: 'confirmedSolution'
				},
				lostReason: {
					title: 'order.lostReason',
					field: 'lostReasonTagId',
					displayAttr: 'value',
					displayType: DisplayType.String,
					selectableColumn: true,
					sortable: 'lostReason.tagId',
					attr: {
						tagId: {
							field: 'lostReason.tagId',
							type: FilterType.Number
						},
						value: {
							field: 'lostReason.value',
							type: FilterType.String
						},
						language: {
							field: 'lostReason.language',
							type: FilterType.String
						}
					}
				},
				competitorId: {
					title: 'order.competitorId',
					field: 'competitorId',
					type: DisplayType.Number,
					selectableColumn: false,
					sortable: 'competitorId',
					attr: {
						id: {
							field: 'competitor.id',
							type: FilterType.Number
						},
						name: {
							field: 'competitor.name',
							type: FilterType.String
						}
					}
				},
				competitor: {
					title: 'order.competitorId',
					field: 'competitor.id',
					displayAttr: 'name',
					displayType: DisplayType.String,
					selectableColumn: true,
					sortable: 'competitor.name',
					attr: {
						id: {
							field: 'competitor.id',
							type: FilterType.Number
						},
						name: {
							field: 'competitor.name',
							type: FilterType.String
						}
					}
				}
			};
			attributes.client = angular.copy(attributes.account);
			attributes.client.selectableColumn = true;
			attributes.campaign = angular.copy(attributes.project);

			var dateFilterPresets = [
				'whenever',
				'currentDay',
				'lastDay',
				'currentWeek',
				'lastWeek',
				'currentMonth',
				'lastMonth',
				'currentQuarter',
				'lastQuarter',
				'currentYear',
				'lastYear',
				'last7days',
				'last14days',
				'last30days',
				'custom'
			];

			var standardFilters = {
				Date: {
					field: 'date',
					title: 'order.date',
					inputType: 'date',
					type: 'dateRange',
					presets: dateFilterPresets
				},
				Currency: {
					field: 'currency',
					title: 'default.currency',
					inputType: 'select',
					multiple: false,
					// For the old filter (remove when salesboard uses filter-sidebar)
					dataPromise: function ($q, AppService) {
						var currencies = _.sortBy(AppService.getMetadata().customerCurrencies, 'iso');
						return $q.when({
							data: _.map(currencies, function (c) {
								return { id: c.iso, name: c.iso };
							})
						});
					},
					options: function () {
						var currencies = _.sortBy(Tools.AppService.getMetadata().customerCurrencies, [
							'masterCurrency',
							'iso'
						]);
						return _.map(currencies, function (c) {
							return { value: c.iso, text: c.iso };
						});
					},
					type: 'list',
					searchField: 'name',
					displayText: _.property('name'),
					multiComparitors: false,
					comparisonType: 'Match',
					selectAllText: function () {
						var currency;
						var role = Tools.AppService.getMetadata().role;
						if (role && role.defaultCurrency) {
							currency = _.find(Tools.AppService.getMetadata().customerCurrencies, {
								iso: role.defaultCurrency
							});
						}

						if (!currency) {
							currency = _.find(Tools.AppService.getMetadata().customerCurrencies, 'masterCurrency');
						}

						return Tools.$translate('default.all') + ' (' + currency.iso + ')';
					},
					hide: true
				},
				ValueRange: {
					field: 'value',
					title: 'default.value',
					type: 'raw',
					inputType: 'range',
					displayType: 'range',
					toUrl: function (filter) {
						var f = { c: filter.comparisonType, v: filter.value };
						if (filter.inactive) {
							f.i = 1;
						} else if (Array.isArray(filter.value) && !filter.value.length) {
							f = undefined;
						}
						return f;
					},
					generate: function () {
						return { value: { start: null, end: null }, comparisonType: null };
					},
					valueSuffix: function (filterProps) {
						const metaData = AppService.getMetadata();
						var activeFilters = filterProps.activeFilters;
						var suffix = metaData.defaultCurrency.iso.toUpperCase();
						if (
							activeFilters.Currency &&
							activeFilters.Currency.value &&
							activeFilters.Currency.value.length
						) {
							suffix = activeFilters.Currency.value[0];
						}
						return suffix;
					},
					build: function (filter, rb, getField, useTags, activeFilters) {
						var selectedCurrency;
						var metadata = AppService.getMetadata();

						if (
							activeFilters &&
							activeFilters.Currency &&
							activeFilters.Currency.value &&
							activeFilters.Currency.value.length
						) {
							selectedCurrency = _.find(metadata.customerCurrencies, function (currency) {
								return currency.iso.toLowerCase() === activeFilters.Currency.value[0].toLowerCase();
							});
						} else {
							selectedCurrency = metadata.defaultCurrency;
						}

						// start
						if (filter.value.start || filter.value.start === 0) {
							var startOr = rb.orBuilder();
							startOr.next();
							var startMyCurrency = startOr.groupBuilder();
							startMyCurrency.addFilter(
								getField('value'),
								rb.comparisonTypes.GreaterThanEquals,
								filter.value.start
							);
							startMyCurrency.addFilter(
								getField('currency'),
								rb.comparisonTypes.Equals,
								selectedCurrency.iso
							);
							startMyCurrency.done();

							startOr.next();

							var startOtherCurrencies = startOr.groupBuilder();
							startOtherCurrencies.addFilter(
								getField('valueInMasterCurrency'),
								rb.comparisonTypes.GreaterThanEquals,
								Math.round(filter.value.start / selectedCurrency.rate)
							);
							startOtherCurrencies.addFilter(
								getField('currency'),
								rb.comparisonTypes.NotEquals,
								selectedCurrency.iso
							);
							startOtherCurrencies.done();
							startOr.done();
						}

						// end
						if (filter.value.end || filter.value.end === 0) {
							var endOr = rb.orBuilder();
							endOr.next();

							var endMyCurrency = endOr.groupBuilder();
							endMyCurrency.addFilter(
								getField('value'),
								rb.comparisonTypes.LessThanEquals,
								filter.value.end
							);
							endMyCurrency.addFilter(
								getField('currency'),
								rb.comparisonTypes.Equals,
								selectedCurrency.iso
							);
							endMyCurrency.done();

							endOr.next();

							var endOtherCurrencies = endOr.groupBuilder();
							endOtherCurrencies.addFilter(
								getField('valueInMasterCurrency'),
								rb.comparisonTypes.LessThanEquals,
								Math.round(filter.value.end / selectedCurrency.rate)
							);
							endOtherCurrencies.addFilter(
								getField('currency'),
								rb.comparisonTypes.NotEquals,
								selectedCurrency.iso
							);
							endOtherCurrencies.done();
							endOr.done();
						}
					}
				},
				OrderRowProduct: {
					field: 'orderRow.product.id',
					title: 'default.products',
					type: 'raw',
					multiple: true,
					displayText: _.property('name'),
					showInactiveToggle: true,
					toUrl: function (filter) {
						return { v: filter.value, c: filter.comparisonType };
					},
					fromUrl: function (rawFilter) {
						return {
							value: rawFilter.v,
							comparisonType: rawFilter.c
						};
					},
					isInactive: function (filter) {
						return !(filter && filter.value && filter.value.length);
					},
					generate: function () {
						return {
							value: null,
							comparisonType: 'Equals'
						};
					},
					build: function (filter, rb, getField) {
						if (filter.value && filter.value.length) {
							if (filter.comparisonType === 'NotEquals') {
								var groupFilter = rb.groupBuilder();
								groupFilter.isNotFilter();
								groupFilter.addFilter(
									getField('orderRow.product.id'),
									rb.comparisonTypes.Equals,
									filter.value
								);
								groupFilter.done();
							} else {
								rb.addFilter(getField('orderRow.product.id'), rb.comparisonTypes.Equals, filter.value);
							}
						}
					}
				},
				Stage: {
					field: 'stage.id',
					title: 'default.stages',
					inputType: 'select',
					dataPromise: function (customerId, AppService, $q) {
						var opts = {
							secondary: {
								text: 'probability',
								suffix: '%'
							}
						};

						return $q.when([
							{
								data: AppService.getStages('won'),
								isGroup: true,
								title: Tools.$translate('order.order'),
								options: opts
							},
							{
								data: AppService.getStages('opportunity'),
								isGroup: true,
								title: Tools.$translate('default.opportunity.singular'),
								options: opts
							}
						]);
					},
					multiple: true,
					multiComparitors: true,
					type: 'list',
					searchField: 'name',
					displayText: _.property('name'),
					listType: 'order'
				},
				Campaign: {
					field: 'project.id',
					search: true,
					title: 'default.campaign',
					inputType: 'select',
					multiple: true,
					includeFields: ['name'],
					searchFn: function (Campaign, AppService, RequestBuilder) {
						var cId = AppService.getCustomerId();

						return function (term, fields, offset, limit) {
							var filter = new RequestBuilder();
							filter.fields = fields;
							filter.offset = offset;
							filter.limit = limit;

							filter.addSort(Campaign.attr.name, true);

							if (term) {
								filter.addFilter(Campaign.attr.name, filter.comparisonTypes.Search, term);
							}

							return Campaign.customer(cId).find(filter.build());
						};
					},
					resource: 'Campaign',
					initAll: true,
					type: 'list',
					displayType: 'listLazy',
					searchField: 'name',
					multiComparitors: true,
					displayText: _.property('name')
				},
				User: generateUserFilter(AppService.AccessType.ORDER, {
					field: 'user.id',
					title: 'default.users',
					parent: 'default.user'
				}),
				UserRole: {
					field: 'user.role.id',
					title: 'default.role',
					inputType: 'select',
					multiple: true,
					dataPromise: function ($q, AppService) {
						return $q.when({ data: _.sortBy(AppService.getRoles('order'), 'name') });
					},
					type: 'list',
					searchField: 'name',
					displayText: _.property('name'),
					multiComparitors: true,
					parent: 'default.user'
				},
				Notes: {
					field: 'notes',
					inputType: 'text',
					type: 'raw',
					generate: function () {
						return {
							value: null
						};
					},
					build: function (filter, rb, getField) {
						if (filter.value) {
							var orBuilder = rb.orBuilder();

							orBuilder.next();
							orBuilder.addFilter(
								getField('comment.description'),
								rb.comparisonTypes.Search,
								filter.value
							);

							orBuilder.next();
							orBuilder.addFilter(getField('notes'), rb.comparisonTypes.Search, filter.value);

							// Also search the main text field directly (not .query) as fallback for long notes
							orBuilder.next();
							orBuilder.addFilter(getField('notes'), rb.comparisonTypes.Match, filter.value);

							orBuilder.done();
						}
					},
					title: 'default.notes',
					search: true,
					displayType: 'text'
				},
				Account: {
					field: 'client.id',
					inputType: 'select',
					multiple: true,
					resource: 'Account',
					type: 'list',
					displayType: 'listLazy',
					search: true,
					includeFields: ['name'],
					searchFn: function (Account, AppService, RequestBuilder) {
						var cId = AppService.getCustomerId();

						return function (term, fields, offset, limit) {
							var filter = new RequestBuilder();
							filter.fields = fields;
							filter.offset = offset;
							filter.limit = limit;

							filter.addSort(Account.attr.name, true);

							if (term) {
								filter.addFilter(Account.attr.name, filter.comparisonTypes.Search, term);
							}

							return Account.customer(cId).find(filter.build());
						};
					},
					searchField: 'name',
					displayText: _.property('name'),
					multiComparitors: true,
					title: 'default.account',
					parent: 'default.account'
				},
				AccountManager: generateUserFilter(AppService.AccessType.ACCOUNT, {
					field: 'client.user.id',
					title: 'default.accountManagers',
					parent: 'default.account'
				}),
				AccountCategory: {
					field: 'client.category.id',
					title: 'default.accountCategories',
					inputType: 'select',
					multiple: true,
					dataPromise: function (customerId, $q, filterName, AppService) {
						var defered = $q.defer();
						var categories = AppService.getCategories('account');

						var categoryMap = _.groupBy(categories, 'categoryType');
						if (filterName.indexOf('Category_') === 0) {
							var categoryId = filterName.split('_')[1];
							defered.resolve({ data: categoryMap[categoryId] });
						} else {
							defered.resolve({ data: categoryMap[0] });
						}

						return defered.promise;
					},
					type: 'list',
					searchField: 'name',
					displayText: _.property('name'),
					multiComparitors: true,
					parent: 'default.account'
				},
				Contact: {
					field: 'contact.id',
					inputType: 'select',
					multiple: true,
					resource: 'Contact',
					type: 'list',
					displayType: 'listLazy',
					includeFields: ['name'],
					searchFn: function (Contact, AppService, RequestBuilder) {
						var cId = AppService.getCustomerId();

						return function (term, fields, offset, limit) {
							var filter = new RequestBuilder();
							filter.fields = fields;
							filter.offset = offset;
							filter.limit = limit;

							filter.addSort(Contact.attr.name, true);

							if (term) {
								filter.addFilter(Contact.attr.name, filter.comparisonTypes.Search, term);
							}

							return Contact.customer(cId).find(filter.build());
						};
					},
					search: true,
					searchField: 'name',
					multiComparitors: true,
					displayText: function (res) {
						return res.name;
					},
					title: 'default.contacts',
					parent: 'filter.orderOther'
				},
				Description: {
					field: 'description',
					title: 'default.description',
					type: 'text',
					inputType: 'text',
					parent: 'filter.orderOther'
				},
				Id: {
					title: 'order.id',
					field: 'id',
					columnPath: 'id',
					inputType: 'number',
					type: 'text',
					parent: 'filter.orderOther'
				},
				CloseDate: {
					field: 'closeDate',
					title: 'default.closeDate',
					inputType: 'date',
					type: 'dateRange',
					presets: dateFilterPresets,
					parent: 'filter.orderOther'
				},
				ProbabilityRange: {
					// the usecase for this on orders is none right
					field: 'probability',
					title: 'default.probability',
					type: 'range',
					inputType: 'range',
					listType: 'opportunity',
					hide: true
				},
				Probability: {
					field: 'probability',
					title: 'default.probability',
					type: 'text',
					inputType: 'text',
					hide: true
				},
				OrderRowProductCategory: {
					field: 'product.category.id',
					title: 'default.products',
					multiple: true,
					hide: true,
					type: 'list',
					inputType: 'select'
				},
				SalesCoach: {
					field: 'salesCoach.id',
					title: 'default.salesProcess',
					inputType: 'select',
					multiple: true,
					type: 'list',
					parent: 'filter.orderOther',
					hide: true
				},
				AdvancedDate: {
					title: 'default.date',
					type: 'raw',
					hide: true,
					fromUrl: function (f) {
						return {
							value: {
								field: f.v.field,
								start: f.v.start ? new Date(f.v.start) : null,
								end: f.v.end ? new Date(f.v.end) : null,
								preset: 'custom'
							}
						};
					},
					generate: function () {
						return {
							value: {
								field: 'date',
								start: null,
								end: null,
								preset: 'custom'
							}
						};
					},
					build: function (filter, rb, getField) {
						var val = filter.value;
						var field = filter.value.field;

						if (val.start) {
							rb.addFilter(getField(field), rb.comparisonTypes.GreaterThanEquals, val.start);
						}
						if (val.end) {
							rb.addFilter(getField(field), rb.comparisonTypes.LowerThanEquals, val.end);
						}

						return;
					}
				},
				Age: {
					title: 'default.age',
					type: 'raw',
					hide: true,
					generate: function () {
						return {
							value: {
								value: null,
								comp: 'gte'
							}
						};
					},
					build: function (filter, rb, getField) {
						var value = filter.value.value;
						var comp = filter.value.comp;

						if (value !== undefined && value !== null) {
							var date = moment().utc().subtract(value, 'day').format();

							rb.addFilter(getField('regDate'), comp, date);
						}
					}
				},
				Status: {
					title: 'default.status',
					type: 'raw',
					hide: true,
					generate: function () {
						return {
							value: 'all'
						};
					},
					build: function (filter, rb, getField) {
						if (filter.value === 'all') {
							return;
						} else if (filter.value === 'active') {
							rb.addFilter(getField('probability'), rb.comparisonTypes.GreaterThan, 0);
						} else if (filter.value === 'lost') {
							rb.addFilter(getField('probability'), rb.comparisonTypes.Equals, 0);
						}
					}
				},
				AgreementId: {
					field: 'agreement.id',
					type: 'raw',
					hide: true,
					generate: function () {
						return {
							value: 'all'
						};
					},
					build: function (filter, rb, getField) {
						if (filter.value === 'all') {
							return;
						} else if (filter.value === 'yes') {
							rb.addFilter(getField('agreement.id'), rb.comparisonTypes.GreaterThan, 0);
						} else if (filter.value === 'no') {
							rb.addFilter(getField('agreement.id'), rb.comparisonTypes.Equals, null);
						}
					}
				},
				FromOpportunity: {
					type: 'raw',
					hide: true,
					generate: function () {
						return {
							value: 'all'
						};
					},
					build: function (filter, rb, getField) {
						if (filter.value === 'all') {
							return;
						} else if (filter.value === 'yes') {
							rb.addFilter(getField('fromOpportunity'), rb.comparisonTypes.Equals, true);
						} else if (filter.value === 'no') {
							rb.addFilter(getField('fromOpportunity'), rb.comparisonTypes.Equals, false);
						}
					}
				},
				// Change this to radio
				IsOpportunity: {
					title: 'default.probability',
					type: 'raw',
					hide: true,
					generate: function () {
						return {
							value: null
						};
					},
					build: function (filter, rb, getField) {
						if (filter.value === null) {
							return;
						} else if (filter.value) {
							rb.addFilter(getField('probability'), rb.comparisonTypes.LessThan, 100);
						} else {
							rb.addFilter(getField('probability'), rb.comparisonTypes.Equals, 100);
						}
					}
				},
				ListSearch: {
					filterName: 'ListSearch',
					type: 'raw',
					generate: function () {
						return {
							value: null
						};
					},
					toUrl: function (filter) {
						return { v: filter.value };
					},
					fromUrl: function (rawFilter) {
						return {
							value: rawFilter.v
						};
					},
					build: function (filter, rb) {
						if (filter.value && filter.value.length) {
							var orBuilder = rb.orBuilder();

							orBuilder.next();
							orBuilder.addFilter({ field: 'client.name' }, rb.comparisonTypes.Wildcard, filter.value);

							orBuilder.next();
							orBuilder.addFilter({ field: 'contact.name' }, rb.comparisonTypes.Wildcard, filter.value);

							orBuilder.next();
							orBuilder.addFilter(
								{ field: 'orderRow.product.name' },
								rb.comparisonTypes.Wildcard,
								filter.value
							);

							orBuilder.next();
							orBuilder.addFilter({ field: 'user.name' }, rb.comparisonTypes.Wildcard, filter.value);

							orBuilder.next();
							orBuilder.addFilter({ field: 'description' }, rb.comparisonTypes.Wildcard, filter.value);

							orBuilder.done();
						}
					}
				},
				RegDate: {
					field: 'regDate',
					title: 'default.created',
					inputType: 'date',
					type: 'dateRange',
					presets: dateFilterPresets
				},
				LostReason: {
					field: 'lostReason.tagId',
					title: 'order.lostReason',
					inputType: 'select',
					multiple: true,
					type: 'list',
					selectableColumn: true,
					parent: 'filter.orderOther',
					displayText: _.property('value'),
					dataPromise: function (customerId, $q) {
						var defered = $q.defer();
						var filter = new RequestBuilder();

						filter.addFilter({ field: 'type' }, comparisonTypes.Equals, 'orderlostreason');
						FieldTranslations.find(filter.build())
							.then(response => {
								const translations = response.data.map(translation => ({
									...translation,
									id: translation.tagId
								}));
								defered.resolve({ data: translations });
							})
							.catch(err => {
								logError(err, 'Failed to fetch lost reasons for filter');
								defered.resolve({ data: [] });
							});

						return defered.promise;
					}
				},
				Competitor: {
					field: 'competitorId',
					title: 'order.competitorId',
					inputType: 'select',
					multiple: true,
					type: 'list',
					selectableColumn: true,
					parent: 'filter.orderOther',
					displayText: _.property('value'),
					dataPromise: function (customerId, $q) {
						var defered = $q.defer();
						Competitor.find()
							.then(response => {
								defered.resolve({ data: response.data });
							})
							.catch(err => {
								logError(err, 'Failed to fetch competitors for filter');
								defered.resolve({ data: [] });
							});

						return defered.promise;
					}
				}
			};

			// The new salesboard still depends on this file. Ideally it shouldn't, but this is a
			// band-aid fix to make these filters match the new ones
			standardFilters.Client = {
				...standardFilters.Account,
				hide: true
			};

			if (AppService.loaded && Tools.AppService.getTotals('products') > 4000) {
				var searchConfig = {
					displayType: 'listLazy',
					search: true,
					searchField: 'name',
					resource: 'Product',
					inputType: 'select',
					searchFn: function () {
						var cId = Tools.AppService.getCustomerId();

						return function (term, fields, offset, limit) {
							var filter = new Tools.RequestBuilder();
							filter.fields = fields;
							filter.offset = offset;
							filter.limit = limit;

							filter.addSort(Tools.Product.attr.name, true);

							if (term) {
								filter.addFilter(Tools.Product.attr.name, filter.comparisonTypes.Search, term);
							}

							return Tools.Product.customer(cId).find(filter.build());
						};
					}
				};

				standardFilters.OrderRowProduct = _.assign(standardFilters.OrderRowProduct, searchConfig);
				standardFilters.OrderRowActiveProduct = Object.assign({}, standardFilters.OrderRowProduct, {
					hide: true,
					searchFn: function () {
						const cId = Tools.AppService.getCustomerId();

						return function (term, fields, offset, limit) {
							const filter = new Tools.RequestBuilder();
							filter.fields = fields;
							filter.offset = offset;
							filter.limit = limit;

							filter.addSort(Tools.Product.attr.name, true);
							filter.addFilter(Tools.Product.attr.active, true);

							if (term) {
								filter.addFilter(Tools.Product.attr.name, filter.comparisonTypes.Search, term);
							}

							return Tools.Product.customer(cId).find(filter.build());
						};
					}
				});
			} else {
				var dataPromiseConfig = {
					displayType: 'virtualizedList',
					inputType: 'selectGroup',
					searchField: 'name',
					dataPromise: function (ProductTreeFilterMeta) {
						return ProductTreeFilterMeta(true, '');
					}
				};

				standardFilters.OrderRowProduct = _.assign(standardFilters.OrderRowProduct, dataPromiseConfig);
				standardFilters.OrderRowActiveProduct = Object.assign({}, standardFilters.OrderRowProduct, {
					hide: true,
					dataPromise: function (ProductTreeFilterMeta) {
						return ProductTreeFilterMeta(false, '');
					}
				});
			}

			if (AppService.loaded) {
				const metadata = AppService.getMetadata();
				const syncJourneyStatus = metadata.params ? metadata.params.SyncJourneyStatus : false;
				attributes.journeyStep.selectableColumn = syncJourneyStatus;
				attributes.clientJourneyStep.selectableColumn = !syncJourneyStatus;
				attributes.contactJourneyStep.selectableColumn = !syncJourneyStatus;
				if (
					metadata.params.brokenFiscalYearEnabled &&
					FeatureHelper.isAvailable(FeatureHelper.Feature.BROKEN_FISCAL_YEAR)
				) {
					insertAfter(dateFilterPresets, 'currentQuarter', 'currentFiscalQuarter');
					insertAfter(dateFilterPresets, 'lastQuarter', 'lastFiscalQuarter');
					insertAfter(dateFilterPresets, 'currentYear', 'currentFiscalYear');
					insertAfter(dateFilterPresets, 'lastYear', 'lastFiscalYear');
				}

				if (Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.CONTRIBUTION_MARGIN)) {
					attributes.contributionMargin.selectableColumn = true;
				}

				const orderStatusApps = metadata.integrations.inits.app_status_order;
				if (orderStatusApps?.length) {
					orderStatusApps.forEach(app => {
						attributes[`AppSyncStatus_${app.id}`] = {
							title: $translate.instant('integrations.appSyncStatus', { name: app.name }),
							field: `AppSyncStatus_${app.id}`,
							sortable: `AppSyncStatus_${app.id}`,
							type: FilterType.String,
							displayType: DisplayType.String,
							selectableColumn: true
						};
						standardFilters[`AppSyncStatus_${app.id}`] = getAppSyncStatusFilter(app, 'order');
					});
				}
				var currencies = metadata.customerCurrencies;

				if (currencies && currencies.length > 1 && metadata.params.MultiCurrency) {
					standardFilters.Currency.hide = false;
				}
			}

			var requiredFields = ['custom'];
			return {
				getAll: function () {
					return attributes;
				},
				attr: attributes,
				standardFilters: standardFilters,
				requiredFields: requiredFields,
				keys: {
					ID: 'id',
					DESCRIPTION: 'description',
					DATE: 'date',
					USER: 'user',
					CONTACT: 'contact',
					ACCOUNT: 'account',
					PROBABILITY: 'probability',
					STAGE: 'stage',
					PRODUCT: 'product',
					CUSTOM: 'custom'
				}
			};
		};
	}
]);
